// extracted by mini-css-extract-plugin
export default {"banner":"taAEU","logo":"sSDfX","text":"t9BUq"};